var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAddaccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "83px",
    viewBox: "0 0 49 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.9999706,62.4244093 L48.9999706,14.3699237 C48.9999706,14.1312127 48.9145786,13.9003759 48.7592276,13.7191328 L37.299307,0.349209086 C37.1093248,0.127562912 36.8319751,5.05340014e-15 36.54005,0 L4,0 C1.790861,4.05812251e-16 -2.705415e-16,1.790861 0,4 L0,62.9485386 C3.75067146e-15,65.1576776 1.790861,66.9485386 4,66.9485386 C4.017044,66.9485386 4.03408782,66.9484296 4.05113042,66.9482118 L45.0511011,66.4240825 C47.2401193,66.3960989 48.9999706,64.6136064 48.9999706,62.4244093 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.00.04-Seller-Accounts-Loss-of-Access",
    transform: "translate(-979.000000, -218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(887.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(92.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,69.9915528 L39,28.1025907 C39.001806,27.6122473 38.7287138,27.1584991 38.2842238,26.9133289 C37.845693,26.6666278 37.3015936,26.6666278 36.8630628,26.9133289 L34.7883753,28.0530381 C34.3273878,28.3249661 33.7452143,28.3249661 33.2842268,28.0530381 L30.421158,26.2295034 C29.9905184,25.9592035 29.4427789,25.925321 28.9792501,26.1403088 L24.6431531,28.2215168 C24.2370352,28.4098198 23.7629648,28.4098198 23.3568469,28.2215168 L19.0207499,26.1502193 C18.5603604,25.9260947 18.0092771,25.9563963 17.578842,26.2295034 L14.7157732,28.0530381 C14.2547857,28.3249661 13.6726122,28.3249661 13.2116247,28.0530381 L11.1369372,26.9133289 C10.6984064,26.6666278 10.154307,26.6666278 9.7157762,26.9133289 C9.27128623,27.1584991 8.99819403,27.6122473 9,28.1025907 L9,70.3385496 C9,71.7879657 10.1749839,72.9629496 11.6244,72.9629496 C11.6366634,72.9629496 11.6489267,72.9628637 11.6611889,72.9626917 L36.4123889,72.6156949 C37.8473173,72.5955781 39,71.4266222 39,69.9915528 Z",
    id: "Path-Copy-2",
    fill: "#E7E8EF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,66.2849349 L43,14.5946863 C43.0022876,13.9895818 42.6563708,13.4296371 42.0933502,13.1270867 C41.5378778,12.822647 40.8486853,12.822647 40.2932129,13.1270867 L37.6652754,14.5335364 C37.0813579,14.8691071 36.3439381,14.8691071 35.7600206,14.5335364 L32.1334668,12.283217 C31.58799,11.9496553 30.8941866,11.9078429 30.3070502,12.173147 L24.8146606,14.7414463 C24.3002446,14.9738202 23.6997554,14.9738202 23.1853394,14.7414463 L17.6929498,12.185377 C17.1097898,11.9087977 16.411751,11.9461912 15.8665332,12.283217 L12.2399794,14.5335364 C11.6560619,14.8691071 10.9186421,14.8691071 10.3347246,14.5335364 L7.70678708,13.1270867 C7.15131472,12.822647 6.46212221,12.822647 5.90664985,13.1270867 C5.34362923,13.4296371 4.99771244,13.9895818 5,14.5946863 L5,66.7154449 C5,68.5048475 6.45059741,69.9554449 8.24,69.9554449 C8.25475012,69.9554449 8.26950006,69.9553441 8.2842488,69.9551427 L39.8042488,69.5246327 C41.5762297,69.5004304 43,68.057081 43,66.2849349 Z",
    id: "Path-Copy",
    fill: "#D6DAEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#C3C6D6",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "61--graph-bar-3",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_66-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_1-5",
    fill: "#D6DAEB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16,
    cy: 16,
    r: 16
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(8.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.395061728,6.82 L3.73333333,6.82 C3.9515199,6.82 4.12839506,6.9990861 4.12839506,7.22 L4.12839506,13.64 L-6.21724894e-15,13.64 L-6.21724894e-15,7.22 C-6.21724894e-15,6.9990861 0.176875161,6.82 0.395061728,6.82 Z",
    id: "Path",
    fill: "#C3C6D6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2617284,-7.10542736e-15 L9.6,-7.10542736e-15 C9.81818657,-7.10542736e-15 9.99506173,0.1790861 9.99506173,0.4 L9.99506173,13.64 L5.86666667,13.64 L5.86666667,0.4 C5.86666667,0.1790861 6.04354183,-7.10542736e-15 6.2617284,-7.10542736e-15 Z",
    id: "Path",
    fill: "#C3C6D6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1481481,2.2 L15.4666667,2.2 C15.6848532,2.2 15.8617284,2.3790861 15.8617284,2.6 L15.8617284,13.64 L11.7530864,13.64 L11.7530864,2.6 C11.7530864,2.3790861 11.9299616,2.2 12.1481481,2.2 Z",
    id: "Path",
    fill: "#C3C6D6",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M40.9999853,0 C45.4182633,-8.11624501e-16 48.9999853,3.581722 48.9999853,8 L48.9999853,8 L42.9999853,8 C41.8954158,8 40.9999853,7.1045695 40.9999853,6 L40.9999853,0 Z",
    id: "Rectangle",
    fill: "#D6DAEB",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,-9 L37,10 C37,12.209139 38.790861,14 41,14 L58,14",
    id: "Path-4",
    fill: "#878994",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E9EAF2",
    fillRule: "nonzero",
    cx: 24.5,
    cy: 82,
    rx: 22.5,
    ry: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddaccount);
export default __webpack_public_path__ + "static/media/ic_addaccount.087d237a097b1ef6a11a39222f48f861.svg";
export { ForwardRef as ReactComponent };